import Vue from 'vue';

const getClient = () => Vue.api.getClient('notifications');

const LAST_NOTIFICATIONS_SIZE = 4;

export const STATUS = {
  LOADING: 'notifications.status.loading',
  SUCCESS: 'notifications.status.success',
  CANCELLED: 'notifications.status.cancelled',
  ERROR: 'notifications.status.error',
};

const initialState = {
  notifications: [],
  status: '',
  error: null,
};

const mutations = {
  setNotifications(state, notifications) {
    state.notifications = notifications;
  },
  setStatus(state, status) {
    state.status = status;
  },
  setError(state, error) {
    state.error = error;
  },
  reset(state) {
    Object.keys(state)
      .forEach((key) => {
        state[key] = initialState[key];
      });
  },
};

const actions = {
  async list({ commit }) {
    try {
      commit('setStatus', STATUS.LOADING);

      const response = await getClient().list(0, LAST_NOTIFICATIONS_SIZE);

      commit('setNotifications', response.list || []);
      commit('setStatus', STATUS.SUCCESS);
    } catch (ex) {
      console.error('error loading last notifications list', ex);
      commit('setError', ex);
      commit('setStatus', STATUS.ERROR);
      commit('setNotifications', []);
    }
  },
  set({ commit }, list = []) {
    commit('setNotifications', list.slice(0, LAST_NOTIFICATIONS_SIZE));
    commit('setStatus', STATUS.SUCCESS);
  },
  reset({ commit }) {
    commit('reset');
  },
};

const getters = {
  list: (state) => state.lastNotifications || [],
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
